import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  GetDockAll(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbansuffix/getdock', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  GetPartAll(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbansuffix/getpart', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  GetPartAllID(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbansuffix/getpartid', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  GetPlantAll(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbansuffix/getplant', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSupplierAll(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbansuffix/getsupplier', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRemark(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbansuffix/getremark', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  Reportallpartserial(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbansuffix/allpartserial', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateRemark(URL, obj, Id, header, success, error) {
    Vue.axios.put(URL + 'kanbansuffix/updateremark/' + Id, obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addStockOut(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbansuffix/addstockout', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getKanbanWait(URL, psId, header, success, error) {
    Vue.axios.get(URL + 'kanbansuffix/sumpartwaitadjust?ps_id=' + psId, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getKanbanSetupHistory(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbansuffix/getpartsetuphistory', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateKanbanSetup(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbansuffix/updatepartsetup', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/kanbansuffix.js